import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/index.css'
import SignUpPasswordScreen from '../screens/SignUpPasswordScreen'
import { ensureUniversalLoginContext } from '../utils/helpers/universalLoginContext.ts'

async function bootstrap() {
  await ensureUniversalLoginContext('signup-password')
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <SignUpPasswordScreen />
    </StrictMode>,
  )
}

bootstrap()

